module.exports = __webpack_public_path__ + "img/e655fff.jpg";